import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PageNotFound } from './PageNotFound';
import { Menu } from './Menu';
import { AppBar, Toolbar, IconButton, Drawer, Typography } from '@mui/material';
import { ConfirmationDialogProvider } from '../../../hooks/dialog.hook';
import { ConfigService } from '../../../services/config.service';
import { useSession } from '../../../hooks/auth.hook';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { ProtectedRoutesConfig } from '../../../config/protected.routes';
import { RoutingConfig } from '../../../config/routes.config';

const drawerWidth = 240;

export function Workspace() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { user, logout } = useSession();

    React.useEffect(() => {
        ConfigService.loadConfig();
    }, []);

    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        setDrawerOpen(!drawerOpen);
    };

    return (
        <BrowserRouter>
            <ConfirmationDialogProvider>
                <div className='app-layout'>
                    <AppBar
                        position='fixed'
                        sx={{
                            width: `calc(100% - ${drawerOpen ? drawerWidth : 0}px)`,
                            ml: `${drawerOpen ? drawerWidth : 0}px`,
                            transition: 'width 0.3s',
                        }}
                    >
                        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <IconButton edge='start' color='inherit' aria-label='menu' onClick={toggleDrawer(true)}>
                                <MenuIcon />
                            </IconButton>
                            <img src="/images/header-logo.png" alt="BaseZero Logo" style={{ height: '60px', marginRight: 'auto' }} />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Typography sx={{ flexGrow: 1 }}>
                                    Welcome, {user?.name || user?.email}
                                </Typography>
                                <IconButton color="error" aria-label='logout' onClick={() => logout()}>
                                    <LogoutIcon />
                                </IconButton>
                            </div>
                        </Toolbar>
                    </AppBar>
                    <Drawer
                        open={drawerOpen}
                        onClose={toggleDrawer(false)}
                        variant='persistent'
                        sx={{
                            width: drawerWidth,
                            flexShrink: 0,
                            '& .MuiDrawer-paper': {
                                width: drawerWidth,
                                boxSizing: 'border-box',
                            },
                        }}
                    >
                        <Menu />
                    </Drawer>
                    <div
                        className='app-main-content'
                        style={{
                            flexGrow: 1,
                            padding: '24px',
                            marginLeft: drawerOpen ? `${drawerWidth}px` : '0',
                            transition: 'margin 0.3s',
                        }}
                    >
                        <Toolbar /> {/* To push content below the AppBar */}
                        <Routes>
                            {RoutingConfig
                                .filter(item => ProtectedRoutesConfig.find((entry) => item.path.startsWith(entry.prefix))?.allowedRoles.includes(user!!.role_id!!))
                                .map((route, index) => (
                                    <Route key={index} path={route.path} element={route.element} />
                                ))}
                            <Route key='notfound' path='*' element={<PageNotFound />} />

                        </Routes>
                    </div>
                </div>
            </ConfirmationDialogProvider>
        </BrowserRouter>
    );
}
